import React from 'react';

function changeClass(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n === 0) return 'flat';
  return n > 0 ? 'up' : 'down';
}

export default function BenchmarkTrendPanel({ history }) {
  if (!history) return null;

  return (
    <div className="benchmark-trend-panel">
      <div className="benchmark-trend-header">
        <span>合成基准 vs 产品累计</span>
        {history.latest_trade_date ? (
          <span className="decision-muted">
            行情至 {history.latest_trade_date}
            {history.latest_expected_nav_date ? ` · 净值至 ${history.latest_expected_nav_date}` : ''}
          </span>
        ) : null}
      </div>

      {!history.available ? (
        <p className="decision-muted">{history.reason || history.note || '暂无趋势数据'}</p>
      ) : (
        <div className="benchmark-trend-grid">
          {(history.windows || []).map((w) => (
            <div className="benchmark-trend-card" key={w.key}>
              <div className="benchmark-trend-label">{w.label}</div>
              <div className="benchmark-trend-metrics">
                <div>
                  <span className="decision-muted">合成</span>
                  <span className={changeClass(w.synthetic_cum_pct)}>{w.synthetic_cum_text}</span>
                </div>
                <div>
                  <span className="decision-muted">产品</span>
                  <span className={changeClass(w.product_cum_pct)}>{w.product_cum_text}</span>
                </div>
                <div>
                  <span className="decision-muted">相对</span>
                  <span className={changeClass(w.vs_bp)}>{w.vs_bp_text}</span>
                </div>
              </div>
              <div className="decision-muted benchmark-trend-meta">
                对齐比较 {w.comparison_days_used ?? w.days_used} 个交易日
                {w.avg_covered_weight_pct != null && w.avg_covered_weight_pct < 100
                  ? ` · 合成覆盖权重约 ${w.avg_covered_weight_pct}%`
                  : ''}
              </div>
            </div>
          ))}
        </div>
      )}

      {history.note ? <p className="decision-muted benchmark-trend-note">{history.note}</p> : null}
    </div>
  );
}
